import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChCreatePsychologicalPsychoTherapyMutation as useChCreatePsychologicalPsychoTherapyMutationType } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChCreatePsychologicalPsychoTherapyMutation.graphql"

const mutation = graphql`
  mutation useChCreatePsychologicalPsychoTherapyMutation($input: Ch_createPsychotherapyPrescriptionInput!) {
    ch_createPsychotherapyPrescription(input: $input) {
      ch_PsychotherapyPrescription {
        id
        ...chPsychologicalPsychoTherapyFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreatePsychologicalPsychoTherapyMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChCreatePsychologicalPsychoTherapyMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreatePsychologicalPsychoTherapyMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreatePsychologicalPsychoTherapyMutation }
